import React from "react";
import SingleSelectNew from "./SingleSelectNew";
const BenchmarksPerTrackedItemType = ({ onChange, selectedValue, className, disabled, benchmarkDropdownOptions, error = null, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(SingleSelectNew, { allowClear: false, "data-test": "benchmark-tracked-item-defination-dropdown", options: benchmarkDropdownOptions, selectedValue: selectedValue, onChange: onChange, valueProperty: "benchmarkCode", textProperty: "benchmarkName", placeholder: "Select benchmark", key: "penchmarkDefinationSelect", className: className, disabled: disabled, error: error })));
};
export default BenchmarksPerTrackedItemType;
